import React from 'react';
import ReactDOM from 'react-dom';
import { unregister } from './registerServiceWorker';
import { ApolloProvider } from 'react-apollo';

import App from './components/App';
import { client } from './apollo/ApolloClient';

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.querySelector('#root'),
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js